export default __webpack_public_path__ + "static/sz_hu_1-83bd7583ce62e69a5cb87e4956e730dd.mp4";